import { NavigationBrandlistProps } from '@/components/atomic/templates/navigation/navigationbrandlist/typings';
import type { EditableComponentProps } from '@adobe/aem-react-editable-components';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service';

const resourceType = `${EnvVarsService.getVar('VITE_APP_ID')}/components/navigationbrandlistcarousel`;

const config = {
	emptyLabel: 'NavigationBRandlistCarousel',
	isEmpty: (props: EditableComponentProps & NavigationBrandlistProps) => {
		if (!props) return true;

		const { navigationBrands, listOfLinks } = props;

		if (
			(!navigationBrands || navigationBrands.length === 0) &&
			(!listOfLinks || listOfLinks.length === 0)
		)
			return true;

		return false;
	},
	resourceType,
};

export default config;
